"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var mobx_react_1 = require("mobx-react");
var TilesList_1 = require("./TilesList");
var routes_1 = require("../../routes");
var CatalogPage = /** @class */ (function (_super) {
    tslib_1.__extends(CatalogPage, _super);
    function CatalogPage() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CatalogPage.prototype.render = function () {
        var categories = this.props.store.data.categories;
        return (react_1.default.createElement("div", { className: "partners wrapper wrapper_big" },
            react_1.default.createElement("div", { className: "section section_less-padding" },
                react_1.default.createElement("h2", { className: "text-header text-header_h2" }, "\u041A\u0430\u0442\u0430\u043B\u043E\u0433 \u0438 \u043A\u0430\u0442\u0435\u0433\u043E\u0440\u0438\u0438"),
                react_1.default.createElement(TilesList_1.TilesList, null, categories.map(function (category) {
                    var _a;
                    return (react_1.default.createElement(TilesList_1.TileItem, { key: category.id, href: routes_1.Routes.catalog + ("/" + category.slug.toLowerCase()), image: (_a = category.image) === null || _a === void 0 ? void 0 : _a.url, title: category.name }));
                })))));
    };
    CatalogPage = tslib_1.__decorate([
        mobx_react_1.inject('store'),
        mobx_react_1.observer
    ], CatalogPage);
    return CatalogPage;
}(react_1.default.Component));
exports.CatalogPage = CatalogPage;
